import { forwardRef, useRef, useImperativeHandle } from 'react';
import { useUi } from '@weareconceptstudio/core';

//* Style
import FileSectionStyle from './style';

//* Components
import Image from '../CustomImage';
import Video from '../Video';

const FileSection = forwardRef(({ file, objectFit = 'cover', className, priority = false, double, onLoad, isOpacityZero, videoLoop = false, autoPlay = false, muted = false, isIcon }, ref) => {
	const { winWidth } = useUi();

	//! Ref
	const fileRef = useRef();

	//! Imperative Handle
	useImperativeHandle(ref, () => fileRef.current, []);

	//! Mobile Desktop
	const doubleSrc = double ? (winWidth >= 1280 ? double?.[0]?.src : double?.[1]?.src || double?.[0]?.src) : null;
	const doubleType = double ? (winWidth >= 1280 ? double?.[0]?.type : double?.[1]?.type || double?.[0]?.type) : null;
	const doubleAlt = double ? (winWidth >= 1280 ? double?.[0]?.alt : double?.[1]?.alt || double?.[0]?.alt) : null;

	return (
		<FileSectionStyle className={`file-section ${className || ''}`}>
			<div className='file-container'>
				{file?.type === 'image' || doubleType === 'image' ? (
					<Image
						ref={fileRef}
						onLoad={onLoad}
						priority={priority}
						className={objectFit}
						src={file?.src || doubleSrc}
						alt={file?.alt || doubleAlt}
						isOpacityZero={isOpacityZero}
					/>
				) : (
					<Video
						isIcon={isIcon}
						onLoad={onLoad}
						muted={muted}
						loop={videoLoop}
						ref={fileRef}
						autoPlay={autoPlay}
						src={file?.src || doubleSrc}
					/>
				)}
			</div>
		</FileSectionStyle>
	);
});

FileSection.displayName = 'FileSection';

export default FileSection;
